import Cookies from 'js-cookie';
import { flagEnabled } from './index';

/**
 * Centralizes all Cotton (Kotlin MW) feature flag logic.
 * - cottonAllowed: Cookie gate for Cotton traffic.
 */
const applePayAvailable = window.ApplePaySession;
const cottonFlagManager = {
  // Akamai cookie
  get cottonCookieValue() {
    return Cookies.get('cotton_shield_allowed');
  },

  get cottonAllowed() {
    return this.cottonCookieValue === 'true';
  },
  get coreUnifiedWalletEnabled() {
    return flagEnabled('coreUnifiedWalletPhase1Enabled')
      && flagEnabled('coreUnifiedWalletPhase2Enabled');
  },

  get isCottonEnabled() {
    if (!this.cottonAllowed) return false;
    // window.ApplePaySession is only a reliable signal while the unified wallet is off
    if (this.coreUnifiedWalletEnabled) return true;
    return applePayAvailable === undefined;
  },
  // Main switch for all oauth Ruby APIs
  get disableRubyApisPCI() {
    return true;
  },
};

export default cottonFlagManager;

export const isCottonSession = () => {
  const { isCottonEnabled } = cottonFlagManager;
  return isCottonEnabled;
};
